<div class="app-container app-theme-white body-tabs-shadow fixed-header fixed-sidebar">
    <app-header></app-header>
    <div class="app-main">
        <!-- Menu Section --->
        <app-menus></app-menus>
        <!-- Menu section End -->
        <div class="app-main__outer">
            <div class="app-main__inner">
                <!-- --------------- -->
                <div class="app-page-title">
                    <div class="page-title-wrapper">
                        <div class="page-title-heading">
                            <div class="page-title-icon">
                                <i class="pe-7s-notebook icon-gradient bg-mixed-hopes"></i>
                            </div>
                            <div>
                                Help <div class="page-title-subheading"></div>
                            </div>
                        </div>
                        <div class="page-title-actions">
                            <div class="d-inline-block dropdown">

                                <!-- <button type="button" class="btn-shadow btn btn-info">
                                    <i class="fa fa-plus fa-lg pointer m-t-5 blackColor" tooltip="Create"
                                        data-toggle="tooltip" data-placement="top"></i></button> -->

                            </div>
                        </div>
                    </div>
                </div>
                <!-- ---------- -->
                <div class="col-md-12">
                  <div class="main-card mb-3 card">
                    <div class="card-body">
                      <div class="table-responsive">
                        <table class="table table-bordered table-striped"
                               style="width: 97%; border-collapse: collapse; margin-left: 15px;">
                          <thead>
                            <tr class="text-center">
                              <th>Business Category</th>
                              <th>Team Name</th>
                              <th>Name</th>
                              <th>E-mail</th>
                              <th>Contact No</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngIf="contacts && contacts.length === 0">
                              <td colspan="5" class="text-center">No data found</td>
                            </tr>
                            <tr *ngFor="let contact of contacts; let i = index" class="text-center">
                              <td>{{ contact.business_category }}</td>
                
                              <!-- Merge Team Name Cells -->
                              <td *ngIf="shouldShowRow(contact.team_name, i)" 
                                  [attr.rowspan]="rowspanMap[contact.team_name]">
                                {{ contact.team_name }}
                              </td>
                
                              <td>{{ contact.name }}</td>
                              <td>{{ contact.email }}</td>
                              <td>{{ contact.mobile_no }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
                
            </div>
        </div>
    </div>
</div>